<template>
  <div :style="{direction:$t('direction')}">
    <div class="dashboard">
      <Sidebar />
      <div class="content">
        <Header />
        <div class="dashboard-content">
          <div class="dashboard-wrapper">
            
            <div class="ar-card new-ticket">
              <div class="ar-card-header">
                <div>ایجاد تیکت جدید</div>
                <div>
                  <router-link :to="{name:'Tickets'}" class="ar-btn size-md primary round">بازگشت</router-link>
                </div>
              </div>
              <div class="ar-card-body">
                <div class="ar-form-group">
                  <label> موضوع</label>
                  <input v-model="item.subject" type="text" class="ar-form-control">
                  <div v-if="errors.subject" class="m-2 text-danger">
                    <small>وارد کردن موضوع تیکت الزامی است.</small>
                  </div>
                </div>
                <div class="ar-form-group">
                  <label> بخش </label>
                  <v-select v-model="item.section" class="ar-form-control" :options="options"></v-select>
                  <div v-if="errors.section" class="m-2 text-danger">
                    <small>انتخاب کردن بخش مربوطه الزامی است.</small>
                  </div>
                </div>
                <div class="ar-form-group">
                  <label> اهمیت </label>
                  <v-select v-model="item.priority" class="ar-form-control" :options="priorities"></v-select>
                  <div v-if="errors.priority" class="m-2 text-danger">
                    <small>انتخاب کردن اهمیت الزامی است.</small>
                  </div>
                </div>
                <div class="ar-form-group">
                  <label> متن تیکت </label>
                  <textarea v-model="item.text" class="ar-form-control" rows="6"></textarea>
                  <div v-if="errors.text" class="m-2 text-danger">
                    <small>وارد کردن متن تیکت الزامی است.</small>
                  </div>
                </div>
                <div class="py-4 text-center">
                  <button @click="addTicket" class="ar-btn size-lg round primary">ثبت تیکت</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Sidebar from './partials/Sidebar'
import Header from './partials/Header'
import {TheMask} from 'vue-the-mask'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import {io} from 'socket.io-client';
export default {
  name: 'AddTicket',
  components:{
    Sidebar,
    Header,
    vSelect,
    TheMask
  },
  data : () => ({
    item:{},
    errors:{},
    options:[
      'احراز هویت',
      'حساب های بانکی',
      'ولت ها',
      'خرید و فروش',
      'واریز و برداشت',
      'تبدیل',
      'متفرقه',
    ],
    priorities:[
      'زیاد',
      'متوسط',
      'کم',
    ],
    socket : null,
  }),
  methods:{
    addTicket (){
      this.activeLoading(true)
      const api_token = this.getToken()
      
      this.$axios.post(`addTicket` , this.item,
      {
        headers: {
          'api_token':api_token
        }
      })
      .then(res => {
        this.activeLoading(false)
        this.errors = {}
        this.item = {}
        this.socket.emit('admin_notification');
        this.$router.push({name:'Tickets'})
      })
      .catch(err => {
        this.activeLoading(false)
        this.errors = err.response.data.errors
      });

    },
  },
  mounted() {
    this.activeLoading(false)
    this.socket = io(this.socketUrl);
    this.checkAuth()
    this.checkConfirmed()
  }
}
</script>
<style>
.vs__selected-options input {
  width: auto !important;
}
.vs__dropdown-menu{
  text-align: right;
}
.new-ticket .v-select {
  height: auto !important;
}
.new-ticket .v-select .vs__selected {
  color: #000 !important;
}
</style>